import type { Product } from './types';

const MIN_SETUP_GBP = 30000;
const MONTHLY_RATE = 0.046;

const roundToPounds = (value: number) => Math.round(value);

/**
 * Enforces Dialgia pricing rules:
 * - Minimum setup fee: £30,000
 * - Minimum monthly: 4.6% of setup
 */
export const normalizeProductPricing = <T extends Product>(product: T): T => {
  const pricing = product.pricing;
  if (!pricing) return product;

  const normalizedSetup = Math.max(pricing.setup ?? 0, MIN_SETUP_GBP);
  const minMonthly = roundToPounds(normalizedSetup * MONTHLY_RATE);
  const normalizedMonthly = Math.max(pricing.monthly ?? 0, minMonthly);

  if (normalizedSetup === pricing.setup && normalizedMonthly === pricing.monthly) return product;

  return {
    ...product,
    pricing: {
      setup: normalizedSetup,
      monthly: normalizedMonthly,
    },
  };
};

export const normalizeProductCatalog = <T extends Product>(products: T[]): T[] =>
  products.map(normalizeProductPricing);
